import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import {styled} from "@mui/material/styles";
import {InputBaseColor} from "../../../config";

export const StyledDateTimePicker =  styled(DateTimePicker)( () => ({
    '.MuiIconButton-root': {
        color: InputBaseColor
    }
}));